import PageHead from "../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";

import Contact from "@/components/Contacts/Contact";
import ContactForm from "@/components/Contacts/Contact-Form";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderStyleFour from "@/components/Header/HeaderStyle-Four";
import Form from "@/components/disclosure/Form";

const DisclosurePage = () => {
  return (
    <>
      <PageHead title="Contact : : Bliss International School" />

      <Provider store={Store}>
        <Context>
          <HeaderStyleFour headerType="" />
          <MobileMenu />
          <div className="bg-white">

          <Form />
          </div>

          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default DisclosurePage;
